import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from '@angular/core';
import { choice_array, choices, formItem } from '../preview-forms.interface';

@Component({
    selector: 'app-form-score',
    templateUrl: './form-score.component.html',
    styleUrls: ['./form-score.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class FormScoreComponent {
  listNumber: choices[] = []
  form!: formItem;
  @Input('view') view: boolean = false;
  @Input('model') set item(v: formItem) {
    this.form = v;
    if (this.form.choices.length > 0) {
      this.listNumber = this.form.choices
      // prefill คะแนนเดิม: ทั้งโหมดดู (view) และโหมดแก้ไขคำตอบ (มี choices_value ที่ parent เติมมา)
      if (this.form.view || (this.form.choices_value && this.form.choices_value.length > 0)) this.default()
    }

  }

  @Output('update') update = new EventEmitter()
  @Output('valid') valid = new EventEmitter()

  trackByIndex(index: number): number { return index; }

  default() {
    if (this.listNumber.length == 0) return
    let model: any = this.form?.choices_value;
    if (!model) return
    let find = this.listNumber?.find((fn: choice_array) => fn.question_choice_id == model[0].question_choice_id)
    if (find) find.status = true
  }

  action(item: choices) {
    this.listNumber.forEach((f: choices) => f.status = false)
    item.status = true
    this.actionValue = item.status
  }

  actionValue: boolean = false;
  updateValue(v: choices) {
    if (this.form.view) return
    this.listNumber.forEach((f: choices) => f.status = false)
    v.status = true
    this.actionValue = v.status
    this.update.emit([v.question_choice_id])
  }

  updateValiDate(e: any) {
    this.valid.emit(e)
  }
}
